/* eslint-disable @typescript-eslint/naming-convention */
import { uniqueId } from 'lodash';
import React, { useEffect } from 'react';

import type { Twitter } from '@swf/cms';

import TwitterSkeletonItem from './TwitterSkeletonItem';

interface Props extends Twitter {
  className?: string;
}

const CMSTwitter: React.FC<Props> = ({ account_name, className }) => {
  const id = uniqueId();

  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://platform.twitter.com/widgets.js';
    script.async = true;

    document.getElementById(id)?.appendChild(script);

    return () => {
      document.getElementById(id)?.removeChild(script);
    };
  }, [id]);

  return (
    <div id={id} className={className} style={{ textAlign: 'center' }}>
      <a
        className="twitter-timeline"
        data-height={600}
        data-width={500}
        href={`https://twitter.com/${account_name}`}
      >
        <TwitterSkeletonItem />
        <TwitterSkeletonItem />
        <TwitterSkeletonItem />
      </a>
    </div>
  );
};

export default CMSTwitter;
